import { css } from '@emotion/react';
import { createPortal } from 'react-dom';

import { useScrollLock } from '@/scrollLock/hooks';
import { cssProps } from '@/theme/theme';
import { cssPropVar } from '@/theme/utils';
import { Typography } from './typography';

const Inner = ({ error }: { error?: string }) => (
	<div
		aria-label="error"
		css={css`
			width: 100%;
			height: 100%;
			background: transparent;
			margin: 0;
			padding: 0;
			display: flex;
			justify-content: center;
			align-items: center;
		`}
	>
		<Typography>
			There was an error.
			<br />
			{!!error && (
				<>
					{error}
					<br />
				</>
			)}
			Please <a href="./">reload.</a>
		</Typography>
	</div>
);

const ErrorScreen = ({ error, isPortal = true }: { error?: string; isPortal?: boolean }) => {
	const { wrapperProps } = useScrollLock('error', isPortal);

	return isPortal ? (
		createPortal(
			<div
				css={css`
					background: ${cssPropVar(cssProps.color.error, 'red')};
					color: ${cssPropVar(cssProps.color.errorContrast, 'white')};
					margin: 0;
					padding: 0;
					z-index: ${cssPropVar(cssProps.zIndex.errorScreen)};
					height: 100%;
				`}
				aria-invalid="true"
				{...wrapperProps}
			>
				<Inner error={error} />
			</div>,
			document.body,
		)
	) : (
		<div
			css={css`
				background: ${cssPropVar(cssProps.color.error, 'red')};
				color: ${cssPropVar(cssProps.color.errorContrast, 'white')};
			`}
			aria-invalid="true"
		>
			<Inner error={error} />
		</div>
	);
};
export default ErrorScreen;
